import { useEffect, useState } from 'react';
import { getWineries, getDeals, getBlogPosts, seedData } from '@/lib/api';
import SEO from '@/components/SEO';
import {
  HeroSection,
  FeaturesSection,
  ShowcaseSections,
  FeaturedWineries,
  DealsSection,
  TestimonialsSection,
  BlogPreview,
  CTASection,
  ContactSection,
  RegionalGuidesShowcase
} from '@/components/home';

const Home = () => {
  const [wineries, setWineries] = useState([]);
  const [deals, setDeals] = useState([]);
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Seed is best-effort — a failed seed (backend down, already seeded,
        // quota error) must NEVER prevent blog/winery data from loading.
        try { await seedData(); } catch (_) {}

        const [wineriesRes, dealsRes, blogRes] = await Promise.all([
          getWineries({ limit: 6 }),
          getDeals({ limit: 6 }),
          getBlogPosts({ limit: 6 })
        ]);
        
        setWineries(wineriesRes.data);
        setDeals(dealsRes.data);
        setBlogPosts(blogRes.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <SEO
        title={null}
        description="Discover great wineries in Napa Valley & Sonoma. FREE app finds wine tasting coupons, deals & discounts to 140+ wineries. Plan your perfect wine country trip!"
        path="/"
        image="https://images.unsplash.com/photo-1701623785014-181cda1bcc37?w=1200"
      />

      <HeroSection />
      
      <FeaturesSection />
      
      <ShowcaseSections />

      <RegionalGuidesShowcase />
      
      {/* Hidden for now: Popular Wineries
      {wineries.length > 0 && <FeaturedWineries wineries={wineries} />}
      */}
      
      {/* Hidden for now: Wine Tasting Deals
      {deals.length > 0 && <DealsSection deals={deals} />}
      */}
      
      <TestimonialsSection />
      
      {/* Blog section hidden — articles pending 2026 content refresh.
          Posts remain in DB and are accessible via /blog/:slug and admin panel. */}
      
      <ContactSection />
      
      <CTASection />
    </>
  );
};

export default Home;
